module.exports = __webpack_public_path__ + "static/media/step4_j.041d0893.png";